export const PROFILE_SECTIONS = [
  {
    id: 'settings',
    label: 'Profile Information',
    description: 'Manage your profile identity details.',
  },
  {
    id: 'security',
    label: 'Session & Security',
    description: 'Review current session and sign out controls.',
  },
  {
    id: 'memberships',
    label: 'Memberships & Roles',
    description: 'See your current roles and tenant access.',
  },
  {
    id: 'favorites',
    label: 'My Favorites',
    description: 'Businesses you have saved.',
  },
];

export function normalizeProfileSection(rawSection) {
  const candidate = String(rawSection || '').trim().toLowerCase();
  if (!candidate) {
    return PROFILE_SECTIONS[0].id;
  }

  return PROFILE_SECTIONS.some((section) => section.id === candidate)
    ? candidate
    : PROFILE_SECTIONS[0].id;
}
